interface Options {
  fallbackLocale?: string;
}

export const useAppLocale = ({ fallbackLocale = 'de-DE' }: Options = { fallbackLocale: 'de-DE' }) => {
  const { $i18n, $domain, $config } = useNuxtApp();
  const locale = $domain.locales?.[0] || $i18n.locale || fallbackLocale;
  const country = $domain.countryCode?.toUpperCase();
  const currencyCode = $domain.currency?.toUpperCase();
  const [lang] = locale.split('-'); // de-DE -> lang=de | country=DE

  const isoCode: string = $config.public.i18n.countries.find(entry => entry.name === country)?.isoCode; // DEU

  return {
    locale,
    lang,
    country,
    isoCode,
    store: $domain.store,
    currencyCode,
  };
};
